import { Text, TextProps } from "react-native";
import { VFile } from "../../model/file/VFile";
import { useVersion } from "../../model/version/useVersion";

export default function FileName(props: { file: VFile } & TextProps) {
  const { data: latestVersion } = useVersion(props.file, -1);
  return <Text {...props}>{latestVersion?.name}</Text>;
}
